module.exports = __webpack_public_path__ + "img/headphone.f43a27a5.svg";